<template>
	<div class="nweaddcheck2">
		<m-title></m-title>
		<div class="planlobby_content" style="overflow-y: auto;">
			<div class="button">
				<!-- <div class="center"> -->
				<button
					style=" font-size: 12px;  margin: 10px 0 0 10px;   border: none;    border-radius: 5px;    height: 30px;    width: 100px;      color: #fff;    background: #17B6A1;    cursor: pointer;"
					@click="returnpage">返回防疫列表</button>
					<button
						style=" font-size: 12px;  margin: 10px 0 0 10px;   border: none;    border-radius: 5px;    height: 30px;    width: 100px;      color: #fff;    background: orangered;    cursor: pointer;"
						@click="updateEPImage">提交修改</button>
				<!-- </div> -->
			</div>
			<div class="top_content">
				<div class="item">
					<span style="color: black;font-weight: bold;display: inline-block;width: 120px;">计划单号:</span>
					<span
						style="color: #17B6A1;    display: inline-block;    width: 180px;">{{ dispatchTruck.pno | formatMsgFun }}
					</span>
					<span style="color: black;font-weight: bold;">车牌号码:</span>
					<span style="color: #17B6A1; ">{{ dispatchTruck.plate | formatMsgFun }}</span>
				</div>

				<div class="item">
					<span style="color: black;font-weight: bold;display: inline-block;width: 120px;">司机姓名:</span>
					<span style="color: #17B6A1;    display: inline-block;    width: 180px;">
						{{ dispatchTruck.driver_name | formatMsgFun }}</span>
					<span style="color: black;font-weight: bold;">司机身份证:</span>
					<span style="color: #17B6A1;  ">
						{{ dispatchTruck.driver_creticard | formatMsgFun }}
					</span>

				</div>
				<div class="item">
					<span style="color: black;font-weight: bold;display: inline-block;width: 120px;">司机手机号:</span>
					<span style="color: #17B6A1;    display: inline-block;    width: 180px;">
						{{ dispatchTruck.telephone | formatMsgFun }}
					</span>
					<span style="color: black;font-weight: bold;">是否落地检:</span>
					<span style="color: #17B6A1;    ">
						{{ dispatchTruck.arriving_check==0?"是":"否" | formatMsgFun }}
					</span>
				</div>
				<div class="item">
					<span style="color: black;font-weight: bold;display: inline-block;width: 120px;">落地检地点:</span>
					<span style="color: #17B6A1;    display: inline-block;    width: 180px;">
						{{ dispatchTruck.arriving_check_place | formatMsgFun }}
					</span>
					<span style="color: black;font-weight: bold;">落地检时间:</span>
					<span style="color: #17B6A1;   ">
						{{ dispatchTruck.arriving_check_time | formatMsgFun }}
					</span>
				</div>
				<div class="item">
					<span style="color: black;font-weight: bold;display: inline-block;width: 120px;">体温是否正常:</span>
					<span style="color: #17B6A1;    display: inline-block;    width: 180px;">
						{{ dispatchTruck.body_temperature==0?"是":"否" | formatMsgFun }}
					</span>

					<span style="color: black;font-weight: bold;">是否有48小时核酸证明:</span>
					<span style="color: #17B6A1;   ">
						{{ dispatchTruck.report48_hours==0?"是":"否" | formatMsgFun }}
					</span>
				</div>
				<div class="item">
					<span style="color: black;font-weight: bold;display: inline-block;width: 120px;">七日内是否出津:</span>
					<span style="color: #17B6A1;    display: inline-block;    width: 180px;">
						{{ dispatchTruck.leave_tianjin==0?"是":"否" | formatMsgFun }}
					</span>

					<span style="color: black;font-weight: bold;">七日途径城市:</span>
					<span style="color: #17B6A1;   ">
						{{ dispatchTruck.tu_jing | formatMsgFun }}
					</span>
				</div>
			</div>

			<div class="cardinfo" style="text-align: center;margin-top: 10px;padding-left: 10%;">

				<img-upload style="float: left;margin-left: 5px;" class="img-upload" title="健康码"
					v-model="dispatchTruck.health_code" />
				<img-upload style="float: left;margin-left: 5px;" class="img-upload" title="行程码"
					v-model="dispatchTruck.itinerary_code" />
				<img-upload style="float: left;margin-left: 5px;" class="img-upload" title="核酸证明"
					v-model="dispatchTruck.nucleic_acid_code" />
				<img-upload style="float: left;margin-left: 5px;" class="img-upload" title="落地核酸记录"
						v-model="dispatchTruck.arriving_check_url" />
				<div style="clear: both;"></div>
			</div>
			
			<p style="margin-left: 10px;font-weight: bold;">
				随车人员列表：
			</p>
			<el-table :data="arrlist.list" border  style="margin-left: 10px; width: 98%;height: 200px; " >
			   <el-table-column show-overflow-tooltip :render-header="renderHeader"
			    label="序号"
			    type="index"
			    width="50px"
			  ></el-table-column>
			  <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="driver_name" label="姓名"></el-table-column>
			  <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="driver_creticard" label="身份证号"></el-table-column>
			  <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="telephone" label="手机号"></el-table-column>
			  <el-table-column show-overflow-tooltip :render-header="renderHeader" label="防疫上传时间">
			    <template v-slot="res">
			      <span>{{ mydateFormat(res.row.fytime, "时分秒") }}</span>
			    </template>
			  </el-table-column>
			  <el-table-column show-overflow-tooltip :render-header="renderHeader" label="七日内是否离津">
			    <template v-slot="res">
			      <span
			        style="color: #ef6b60"
			        class="el_spanfontstyle"
			        v-if="res.row.leave_tianjin == 0"
			        >是</span
			      >
			      <span
			        style="color: #448aff"
			        class="el_spanfontstyle"
			        v-if="res.row.leave_tianjin == 1"
			        >否</span
			      >
			    </template>
			  </el-table-column>
			   <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="tu_jing" label="七日途经地"></el-table-column>
			   <el-table-column show-overflow-tooltip :render-header="renderHeader" label="健康码是否为绿码">
			     <template v-slot="res">
			       <span
			         style="color: #ef6b60"
			         class="el_spanfontstyle">是</span
			       >
			     </template>
			   </el-table-column>
			  <el-table-column show-overflow-tooltip :render-header="renderHeader" label="体温是否正常">
			    <template v-slot="res">
			      <span
			        style="color: #ef6b60"
			        class="el_spanfontstyle"
			        v-if="res.row.body_temperature == 0"
			        >正常</span
			      >
			      <span
			        style="color: #448aff"
			        class="el_spanfontstyle"
			        v-if="res.row.body_temperature == 1"
			        >否</span
			      >
			    </template>
			  </el-table-column>
			  <el-table-column show-overflow-tooltip :render-header="renderHeader" label="是否落地检">
			    <template v-slot="res">
			      <span
			        style="color: #ef6b60"
			        class="el_spanfontstyle"
			        v-if="res.row.arriving_check == 0"
			        >是</span
			      >
			      <span
			        style="color: #448aff"
			        class="el_spanfontstyle"
			        v-if="res.row.arriving_check == 1"
			        >否</span
			      >
			    </template>
			  </el-table-column>
			  <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="arriving_check_place" label="检查地点"></el-table-column>
			  <el-table-column show-overflow-tooltip :render-header="renderHeader" label="检查时间">
			    <template v-slot="res">
			      <span>{{ mydateFormat(res.row.arriving_check_time, "时分秒") }}</span>
			    </template>
			  </el-table-column>
			  
			  <el-table-column show-overflow-tooltip :render-header="renderHeader" label="是否有48小时核酸阴性证明">
			    <template v-slot="res">
			      <span
			        style="color: #ef6b60"
			        class="el_spanfontstyle"
			        v-if="res.row.report48_hours == 0"
			        >是</span
			      >
			      <span
			        style="color: #448aff"
			        class="el_spanfontstyle"
			        v-if="res.row.report48_hours == 1"
			        >否</span
			      >
			    </template>
			  </el-table-column>
			</el-table>
			
		</div>

	</div>
</template>
<script>
	import mTitle from "@/components/mTitle";
	import mSuperIpt from "@/components/mSuperIpt.vue";
	import {
		mapGetters
	} from "vuex";
	import ImgUpload from "@/components/Img-upload.vue";
	export default {
		name: "epinfomsg",
		data() {
			return {
				arrlist: { list: [] },
				dispatchTruck: {},
				conditions: {
					page: 1,
					limit: 20,
					peopleType: "0",
					id: this.$route.params.id
				},
				conditionssx: {
					page: 1,
					limit: 20,
					peopleType: "1",
					id: this.$route.params.id
				},
			};
		},
		computed: {
			...mapGetters(["navigationMsgGt"]),
		},
		components: {
			mTitle,
			mSuperIpt,
			ImgUpload
		},
		created() {
			this.getiteminfo();
			this.getjobdetails();
		},
		methods: {
			
			async updateEPImage(){
				const { data } = await this.$http(
				  "api1",
				  "/driver/epidemicprevention/updateEPImage",
				  "get",
				  {
					  id:this.$route.params.id,
					  health_code:this.dispatchTruck.health_code,
					  itinerary_code:this.dispatchTruck.itinerary_code,
					  nucleic_acid_code:this.dispatchTruck.nucleic_acid_code,
					  arriving_check_url:this.dispatchTruck.arriving_check_url
				  }
				);
				if (data.code != 0) {
					return this.$message.error(data.msg);
				}else{
					return this.$message.success("保存成功");
				}
			},
			async getjobdetails() {
			  const { data } = await this.$http(
			    "api1",
			    "/driver/epidemicprevention/getEpidemicPrevention",
			    "get",
			    this.conditionssx
			  );
			  if (data.code != 0) return this.$message.error(data.msg);
			  this.suttlesum = data.suttlesum;
			  this.count = data.count;
			  this.arrlist = data.data;
			},
			async getiteminfo() {
				const {
					data
				} = await this.$http(
					"api1",
					"/driver/epidemicprevention/getEpidemicPrevention",
					"get",
					this.conditions
				);
				if (data.code != 0) return console.log("infomsg获取详情失败");
				console.log(data["data"]["list"][0]);
				this.dispatchTruck = data["data"]["list"][0];
			},
			returnpage() {
				 this.$router.push("/statistics/eplist");
			},
		},
	};
</script>
<style lang="scss" scoped>
	.nweaddcheck2 {
		position: relative;
		height: 100%;

		.planlobby_content {
			// position: absolute;
			// top: 30px;
			// bottom: 0;
			width: 100%;
			background: #fff;

			.top_content {
				position: relative;
				// height: 50%;
				box-sizing: border-box;

				.item {
					margin: 0 auto;
					width: 50%;
					height: 11%;
					margin-top: 10px;
					// text-align: right;
					font-size: 80%;

					&::before {
						display: inline-block;
						content: "";
						height: 65%;
						vertical-align: middle;
					}

					.input,
					.inpstyNew {
						float: right;
						width: 72%;
						height: 65%;
						margin-left: 5%;
						text-align: left;
						background: #f3f4f5;
						border-radius: 2px;
					}

					.inpstyNew {
						color: #666666;
						background: transparent;
					}

					.inpstyNew::before {
						content: "";
						display: inline-block;
						height: 100%;
						vertical-align: middle;
					}
				}
			}

			.card {
				box-sizing: border-box;
				height: 30%;

				.planlobby_content2 {
					height: 100%;
					width: 100%;
					padding-top: 10px;
					margin: 0 auto;
					text-align: center;
					box-sizing: border-box;

					.bottextarea {
						position: relative;
						display: inline-block;
						box-sizing: border-box;
						height: 90%;
						width: 24%;
						margin-right: 1%;
						background: #f3f4f5;
						background-size: 100% 100%;

						&:last-of-type {
							margin: 0;
						}

						.imginfo {
							position: absolute;
							z-index: 999;
							top: -15px;
							left: 50%;
							font-size: 13px;
							transform: translateX(-50%);
						}
					}
				}
			}

			.bottom_div {
				position: relative;
				margin: 30px auto;
				width: 300px;
				overflow: hidden;

				.botton_btn {
					display: inline-block;
					cursor: pointer;
					width: 80px;
					margin: 0 10px;
					line-height: 38px;
					text-align: center;
					border-radius: 5px;
					color: #fff;
					font-size: 13px;
					background: #17B6A1;
				}
			}
		}
	}

	.mpartivulars {
		position: relative;
		height: 100%;
		background: #fff;

		.componentSty_content {
			position: absolute;
			top: 30px;
			bottom: 0;
			width: 100%;
			background: #fff;

			.icon {
				position: absolute;
				right: 10px;
				top: 10px;
				z-index: 999;
				font-size: 20px;
				color: red;
			}
		}

		.planlobby_content {
			position: relative;
			height: 65%;
			width: 100%;
			border-radius: 2px;

			.planlobby_content_info {
				position: absolute;
				z-index: 999;
				width: 70%;
				left: 50%;
				top: 1%;
				bottom: 0;
				transform: translateX(-50%);

				.leftbox,
				.rightbox {
					float: left;
					height: 100%;
					width: 50%;
				}

				.planlobby_content_item {
					height: 10%;
					font-size: 80%;
					margin-top: 5px;

					.spansty {
						float: left;
						font-size: 80%;
						box-sizing: border-box;
						width: 35%;
						height: 70%;
						text-align: center;
					}

					.spansty::before,
					.inpstyNew::before {
						content: "";
						display: inline-block;
						height: 100%;
						vertical-align: middle;
					}

					.inpsty,
					.inpstyNew {
						box-sizing: border-box;
						float: right;
						border: none;
						outline: none;
						font-size: 80%;
						width: 65%;
						height: 70%;
						border-radius: 2px;
						background: #f3f4f5;
					}

					.inpstyNew {
						background: transparent;
					}
				}
			}
		}

		.cardinfo {
			// position: relative;
			// top: 5%;

			height: 35%;
			display: flex;
			flex-direction: column;
			padding-top: 8px;

			.planlobby_content_bot {
				// position: absolute;
				// left: 50%;
				// transform: translateX(-50%);
				// width: 90%;
				// height: 80%;
				display: flex;
				// padding: 0 20px;
				padding-left: 20px;
				flex: 1;
				overflow: hidden;

				.img-upload {
					flex: 1;
					margin-right: 20px;
					height: 100%;
				}

				// .content {
				// position: relative;
				// float: left;
				// height: 100%;
				// width: 19%;
				// margin-left: 1%;
				// border-radius: 2px;
				// font-size: 12px;
				// background: #f3f4f5;
				// cursor: pointer;

				// .photo_titile {
				//   position: absolute;
				//   top: -20px;
				//   left: 50%;
				//   transform: translateX(-50%);
				//   color: #868687;
				//   font-size: 80%;
				// }
				// }
			}

			.button {
				// position: absolute;
				// top: 80%;
				// bottom: 0;
				// width: 100%;
				text-align: center;
				height: 60px;
				line-height: 60px;
				flex-shrink: 0;
				// .center {
				// position: absolute;
				// left: 50%;
				// top: 50%;
				// height: 70%;
				// width: 50%;
				// transform: translate(-50%, -50%);

				.btn {
					border: none;
					border-radius: 2px;
					height: 36px;
					width: 100px;
					margin-left: 20px;
					color: #fff;
					background: #17B6A1;
					cursor: pointer;
				}

				// }
			}
		}

		.imgcontent {
			width: 100%;
			height: 600px;
			text-align: center;

			.img {
				width: auto;
				max-width: 100%;
				height: 100%;
			}
		}
	}
</style>
